module.exports = __webpack_public_path__ + "img/hevans.7b9cc1c4.png";